import { render } from "./df-ui2-navbar.vue?vue&type=template&id=52188ceb&scoped=true"
import script from "./df-ui2-navbar.vue?vue&type=script&lang=js"
export * from "./df-ui2-navbar.vue?vue&type=script&lang=js"

import "./df-ui2-navbar.vue?vue&type=style&index=0&id=52188ceb&scoped=true&lang=scss"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52188ceb"]])

export default __exports__